// Outreach role flags derived from the real authenticated user.
//
// Authorization model (matches backend):
//   - Super Admin (active_role === 'SUPER_ADMIN') gets admin rights:
//     campaigns CRUD, all PM queues, account management, etc.
//   - Everyone else (active_role === 'USER') is treated as a potential PM:
//     they only see /my-outreach + their daily review queue, and only entries
//     where their user is the assigned_pm on backend.
//
// No separate "PM role" exists in this system — assignment IS the access control.
// The backend (see outreach/views/enrichment_queue.py::_can_act_on_entry) enforces
// data isolation regardless of UI flags.

export const getOutreachRoleFlags = (userInfo) => {
  const role = userInfo?.active_role || 'USER';
  const isAdmin = role === 'SUPER_ADMIN';
  return {
    effective_role:           role,
    is_admin:                 isAdmin,
    is_pm:                    !isAdmin,
    pm_user_id:               userInfo?.pk ?? null,
    // Kept for sidebar back-compat (was used by the now-removed demo switcher).
    has_outreach_assignments: !isAdmin,
  };
};
